module.exports = __webpack_public_path__ + "img/banner.fc7e59d.png";